var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.5a.75.75 0 01-.75.75h-6a.75.75 0 110-1.5h6a.75.75 0 01.75.75zm7.28 11.03a.747.747 0 01-1.06 0l-4.693-4.693a8.26 8.26 0 111.06-1.06l4.694 4.693a.748.748 0 010 1.06zM10.5 17.25a6.75 6.75 0 10-6.75-6.75 6.758 6.758 0 006.75 6.75z",
    fill: "#15131C"
  })));
}

export default SvgZoomOut;